/** @jsxImportSource @emotion/react */
import { Box, css } from '@mui/material';
import React, { useState } from 'react';
import Loader from '../../../../shared/components/molecules/loader';
import { ChatType } from '../../../home/v1/components/chat-list-section/chat-row/typings';
import { ChatProfileAvatar } from '../../../home/v1/atoms/chat-profile-avatar';
import { BusinessProfileDetails } from '../../../../shared/typings/business-profile';
import { Organization } from '../../../login/v1/typings';

const sidebarOrganisationTitleHeight = 40;

const ChatAvatarLoading = ({
  businessDetailsLoading,
  businessDetails,
  currentOrg,
  wabaPhoneNumber,
}: {
  businessDetailsLoading: boolean;
  businessDetails: BusinessProfileDetails | undefined;
  currentOrg: Organization | null;
  wabaPhoneNumber: string | undefined;
}) => {
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  if (businessDetailsLoading) {
    return (
      <Box
        css={css`
          height: ${sidebarOrganisationTitleHeight - 12}px;
          min-height: ${sidebarOrganisationTitleHeight - 12}px;
          width: ${sidebarOrganisationTitleHeight - 12}px;
          min-width: ${sidebarOrganisationTitleHeight - 12}px;
          margin: 0px;
          padding: 0px;
        `}
      >
        <Loader size={sidebarOrganisationTitleHeight - 18} />
      </Box>
    );
  }

  if (businessDetails?.logo && businessDetails?.logo.length > 0 && !isError && !isLoading) {
    return (
      <img
        onError={() => setIsError(true)}
        src={businessDetails?.logo}
        onLoad={() => setIsLoading(false)}
        onLoadStart={() => setIsLoading(true)}
        alt={currentOrg?.name ?? 'organisation profile logo'}
        css={css`
          height: ${sidebarOrganisationTitleHeight - 12}px;
          min-height: ${sidebarOrganisationTitleHeight - 12}px;
          width: 100%;
          min-width: 100%;
          margin: 0px;
          padding: 0px;
          object-fit: contain;
        `}
      />
    );
  }
  return (
    <ChatProfileAvatar
      chatType={ChatType.INDIVIDUAL}
      name={currentOrg?.name}
      phoneNumber={wabaPhoneNumber}
      styles={{
        height: sidebarOrganisationTitleHeight - 12,
        width: sidebarOrganisationTitleHeight - 12,
        margin: 0,
      }}
    />
  );
};

export default ChatAvatarLoading;
